import { CloudinaryImage } from '@cloudinary/url-gen';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import parse from 'html-react-parser';

import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { DynamicText } from '../../api/dynamixText';
import { getMediaMegjelenes, getVideoKategoria } from '../../api/video';
import ColorModeIconDropdown from '../../themes/MuiTheme/ColorModeIconDropdown';
import Footer from '../footer/Footer';
import LandingInfoBoxes from '../info-boxes/landig-info-box';
import Subscriptions from '../subscriptions/activeSubscriptions';
import VideoKategoria from '../video/video-kategoria/VideoKategoria';
import Comments from './Comments';
import Members from './Members';
import WelcomeText from './WelcomeText';

export default function LandingPage() {
  const loginRef = useRef(null);

  const onNavigateToSubscribeRef = () => {
    loginRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const logo = new CloudinaryImage('tanyaegyetem/TE_logo_transparent', {
    cloudName: 'scriptantia',
  });

  const navigate = useNavigate();
  const [kategoria, setKategoria] = useState([]);
  const [mediaMegjelenes, setMediaMegjelenes] = useState([]);

  const onLoginClick = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  const onSubscribeClick = useCallback(() => {
    navigate('/subscribe');
  }, [navigate]);

  const bookOrderClick = useCallback(() => {
    navigate('/book-order');
  }, [navigate]);

  useEffect(() => {
    getVideoKategoria().then(setKategoria);
    getMediaMegjelenes().then(setMediaMegjelenes);
  }, []);

  return (
    <Box>
      <Box
        position='fixed'
        sx={{
          top: 10,
          right: 20,
        }}
      >
        <ColorModeIconDropdown size='medium' />
      </Box>
      <Box textAlign='right' my={2}>
        <Button
          variant='outlined'
          color='highlight'
          onClick={onLoginClick}
          fullWidth
          sx={{ maxWidth: 300, height: 50, typography: 'h3' }}
        >
          <Typography
            variant='h4'
            sx={{
              fontSize: {
                xs: '0.8rem',
                sm: '1rem',
              },
            }}
          >
            {DynamicText('LOGIN_MEMBERS')}
          </Typography>
        </Button>
      </Box>
      <Box textAlign='center' my={2}>
        <Typography variant='subtitle1' p={1}>
          {parse(DynamicText('LANDING_1_TEXT1'))}
        </Typography>
        <Typography variant='subtitle1' p={1}>
          {parse(DynamicText('LANDING_1_TEXT2'))}
        </Typography>
      </Box>

      <Box textAlign='center' my={2}>
        <LandingInfoBoxes />
      </Box>
      <Box display='flex' justifyContent='center' my={2}>
        <Button
          variant='outlined'
          onClick={onNavigateToSubscribeRef}
          fullWidth
          sx={{ maxWidth: 380, height: 70, typography: 'h4' }}
        >
          <Typography
            variant='h4'
            sx={{
              fontSize: {
                xs: '1.1rem',
                sm: '1.3rem',
              },
            }}
          >
            {DynamicText('JOIN_BUTTON')}
          </Typography>
        </Button>
      </Box>
      <Box textAlign='center' my={2}>
        <WelcomeText />
      </Box>
      <Box textAlign='center' my={2}>
        <Members />
      </Box>
      <Box textAlign='center' my={2}>
        <Typography variant='h3'>Mit mondanak rólunk?</Typography>
        <Comments />
      </Box>
      <Stack ref={loginRef} spacing={2} alignItems='center'>
        <Subscriptions login />
      </Stack>
      <Box display='flex' justifyContent='center' my={2}>
        <Button
          variant='outlined'
          onClick={onSubscribeClick}
          fullWidth
          sx={{ maxWidth: 400, height: 70, typography: 'h4' }}
        >
          <Typography
            variant='h4'
            sx={{
              fontSize: {
                xs: '1.1rem',
                sm: '1.3rem',
              },
            }}
          >
            {DynamicText('JOIN_BUTTON')}
          </Typography>
        </Button>
      </Box>
      <Stack spacing={2} alignItems='center'>
        <Typography variant='h3'>Média megjelenéseink</Typography>
        {mediaMegjelenes.map((mm) => (
          <Card key={mm.videoId} sx={{ width: '90%' }}>
            <CardContent>
              <Typography variant='h6'>{mm.videoCim}</Typography>
              <Typography
                dangerouslySetInnerHTML={{ __html: mm.videoLeiras }}
              />
              <Box
                width='100%'
                sx={{ position: 'relative', paddingTop: '56.25%' }} // 16:9 arány
              >
                <ReactPlayer
                  style={{ position: 'absolute', top: 0, left: 0 }}
                  width='100%'
                  height='100%'
                  light={true}
                  url={mm.videoUrl}
                  controls
                />
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
      <Stack spacing={2} alignItems='center'>
        <Typography variant='h3' textAlign={'center'}>
          Folyamatosan bővülő tartalmaink
        </Typography>
        {kategoria.map((vk) => (
          <Card key={vk.kategoriaId} sx={{ width: '90%' }}>
            <CardContent>
              <VideoKategoria
                katKey={vk.kategoriaId}
                kategoriaNev={vk.kategoriaNev}
                cldImageName={vk.cldImageName}
                katDescr={vk.kategoriaDescr}
                onKatClick={() => {}}
              />
            </CardContent>
          </Card>
        ))}
      </Stack>
      <Box display='flex' justifyContent='center' my={2}>
        <Button
          variant='outlined'
          onClick={onSubscribeClick}
          fullWidth
          sx={{ maxWidth: 400, height: 70, typography: 'h4' }}
        >
          <Typography
            variant='h4'
            sx={{
              fontSize: {
                xs: '1.1rem',
                sm: '1.3rem',
              },
            }}
          >
            {DynamicText('JOIN_BUTTON')}
          </Typography>
        </Button>
      </Box>
      <Box display='flex' justifyContent='center' my={3}>
        <Box
          width='80%'
          sx={{ position: 'relative', paddingTop: '56.25%' }} // 16:9 arány
        >
          <ReactPlayer
            style={{ position: 'absolute', top: 0, left: 0 }}
            width='100%'
            height='100%'
            url='https://vimeo.com/813760803' // 'https://vimeo.com/347119375'
            controls
            config={{
              youtube: {
                playerVars: {
                  playsinline: 1, // iOS optimalizálás
                  rel: 0, // Ne ajánljon más videókat
                  modestbranding: 1, // Minimalizált branding
                },
                embedOptions: {
                  origin: window.location.origin, // Segíthet CORS problémák esetén
                },
              },
              vimeo: {
                playerOptions: {
                  dnt: 1, // Ne gyűjtsön követési adatokat
                },
              },
            }}
          />
        </Box>
      </Box>

      {/*
      <Box textAlign='center' my={4}>
        <Typography variant='h6'>
          Megjelent az új könyvünk az <strong>"Üvegbe zárt szabadság"</strong>{' '}
          címmel.
        </Typography>
        <Card sx={{ maxWidth: 345, margin: 'auto', mt: 2 }}>
          <Box
            sx={{
              height: 200,
              backgroundSize: 'cover',
              backgroundImage: `url(${process.env.PUBLIC_URL}/img/books/Book1.jpg)`,
            }}
          />
          <CardContent>
            <Typography>
              A könyvünk már csak korlátozott darabszámban kapható! Heti két
              alkalommal Cegléden és Budapesten vehető át. Időpont egyeztetés a
              ruszkai.krisztina@gmail.com címen lehetséges.
            </Typography>
          </CardContent>
        </Card>
      </Box>
      */}
      <Footer />
    </Box>
  );
}
